// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz
(() => {
  const hamtaRadHojd = () => {
    const sond = document.createElement('div');
    sond.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;inset-inline-start:0;block-size:var(--grid-row-height);';
    document.documentElement.appendChild(sond);
    const v = sond.getBoundingClientRect().height;
    sond.remove();
    return v > 0 ? v : 1;
  };
  const arDesktop = () => window.matchMedia('(min-width: 48.0625rem)').matches;
  const valjGalleri = (mal) => mal?.closest('[data-imgmod-galleri]');
  const valjIndex = (galleri) => galleri.querySelector('[data-imgmod-index]');
  const valjSpar = (galleri) => galleri.querySelector('[data-imgmod-spar]');
  const hamtaAntal = (galleri) => Math.max(1, +galleri.dataset.imgmodAntal || 1);
  const hamtaIndex = (galleri) => {
    const spar = valjSpar(galleri);
    if (!spar) return 0;
    const raw = getComputedStyle(spar).transform;
    if (!raw || raw === 'none') return 0;
    const m = raw.match(/matrix\(([^)]+)\)/);
    if (!m) return 0;
    const x = parseFloat(m[1].split(',')[4]) || 0;
    const bredd = galleri.querySelector('[data-imgmod-ram]')?.clientWidth || 1;
    return Math.max(0, Math.round(Math.abs(x) / bredd));
  };
  const synkaIndex = (galleri, index) => {
    const antal = hamtaAntal(galleri);
    const i = ((index % antal) + antal) % antal;
    const spar = valjSpar(galleri);
    if (spar) spar.style.transform = `translate3d(${-i * 100}%, 0, 0)`;
    const etikett = valjIndex(galleri);
    if (etikett) etikett.textContent = `${i + 1} / ${antal}`;
    galleri.dataset.imgmodAktiv = String(i);
    return i;
  };
  const steg = (galleri, delta) => synkaIndex(galleri, hamtaIndex(galleri) + delta);
  const bindDrag = (galleri) => {
    const ram = galleri.querySelector('[data-imgmod-ram]');
    const spar = valjSpar(galleri);
    if (!ram || !spar || ram.dataset.imgmodDrag === 'klar') return;
    ram.dataset.imgmodDrag = 'klar';
    let startX = 0, startIndex = 0, aktiv = false;
    const avsluta = () => {
      if (!aktiv) return;
      aktiv = false;
      ram.dataset.imgmodDrar = 'nej';
      const diff = ram._imgmodDiff || 0;
      ram._imgmodDiff = 0;
      if (Math.abs(diff) > 40) steg(galleri, diff > 0 ? -1 : 1);
      else synkaIndex(galleri, startIndex);
    };
    ram.addEventListener('pointerdown', (e) => {
      if (e.button !== 0) return;
      aktiv = true;
      startX = e.clientX;
      startIndex = hamtaIndex(galleri);
      ram.dataset.imgmodDrar = 'ja';
      ram.setPointerCapture(e.pointerId);
    });
    ram.addEventListener('pointermove', (e) => {
      if (!aktiv) return;
      const diff = e.clientX - startX;
      ram._imgmodDiff = diff;
      const bredd = ram.clientWidth || 1;
      spar.style.transform = `translate3d(${startIndex * -100 + (diff / bredd) * 100}%, 0, 0)`;
    });
    ram.addEventListener('pointerup', avsluta);
    ram.addEventListener('pointercancel', avsluta);
  };
  const hamtaBildNaturligHojd = (cell, img) => {
    const bredd = cell.clientWidth || 1;
    const natW = +img.dataset.imgmodNatW || img.naturalWidth || 0;
    const natH = +img.dataset.imgmodNatH || img.naturalHeight || 0;
    if (!natW || !natH) return 0;
    return bredd * (natH / natW);
  };
  const hamtaMaxBildHojd = (cell) => {
    const bilder = [...cell.querySelectorAll('.bxyz-imgmodular-1__bild[data-imgmod-nat-w]')];
    if (!bilder.length) return 0;
    return bilder.reduce((max, img) => Math.max(max, hamtaBildNaturligHojd(cell, img)), 0);
  };
  const hamtaMetaHojd = (cell) => cell.querySelector('.bxyz-imgmodular-1__meta')?.offsetHeight || 0;
  const hamtaFallbackSpan = (cell) => {
    const nyckel = arDesktop() ? 'imgmodDRadSpan' : 'imgmodMRadSpan';
    return Math.max(1, +cell.dataset[nyckel] || 1);
  };
  const beraknaSpan = (cell) => {
    const rh = hamtaRadHojd();
    const maxBild = hamtaMaxBildHojd(cell);
    if (!maxBild) return hamtaFallbackSpan(cell);
    const meta = hamtaMetaHojd(cell);
    const innehall = maxBild + meta + rh * 2;
    const gap = parseFloat(getComputedStyle(cell.parentElement).rowGap) || 0;
    const span = Math.ceil((innehall + gap) / (rh + gap));
    return Math.max(hamtaFallbackSpan(cell), span);
  };
  const appliceraCell = (cell) => {
    const radStart = arDesktop() ? +cell.dataset.imgmodDRadStart : +cell.dataset.imgmodMRadStart;
    const span = beraknaSpan(cell);
    const radEnd = radStart + span;
    const radProp = arDesktop() ? '--imgmod-d-rad-end' : '--imgmod-m-rad-end';
    cell.style.setProperty(radProp, String(radEnd));
    cell.dataset.imgmodSpan = String(span);
    return radEnd;
  };
  const layoutSektion = (rot) => {
    const grid = rot.querySelector('.bxyz-imgmodular-1__grid');
    if (!grid) return;
    const desktop = arDesktop();
    const cells = [...rot.querySelectorAll('[data-imgmod-cell]')];
    const totalKols = desktop
      ? Math.max(1, +rot.dataset.imgmodKolsDesktop || 6)
      : Math.max(1, +rot.dataset.imgmodKolsMobil || 2);
    const gapRH = desktop ? 1 : 0;
    const autoAttr = desktop ? 'imgmodDAuto' : 'imgmodMAuto';
    const spanAttr = desktop ? 'imgmodDKolSpan' : 'imgmodMKolSpan';
    const radStartProp = desktop ? '--imgmod-d-rad-start' : '--imgmod-m-rad-start';
    const radStartDataKey = desktop ? 'imgmodDRadStart' : 'imgmodMRadStart';

    let maxRad = desktop ? (+rot.dataset.imgmodRaderDesktop || 12) : (+rot.dataset.imgmodRaderMobil || 16);
    let cursorCol = 1, rowTop = 1, rowBottomMax = 0;

    cells.forEach((cell) => {
      const auto = cell.dataset[autoAttr] === 'ja';
      if (auto) {
        const span = Math.max(1, Math.min(totalKols, +cell.dataset[spanAttr] || (desktop ? 3 : totalKols)));
        const overflows = cursorCol > 1 && cursorCol + span - 1 > totalKols;
        const collides = cursorCol === 1 && rowBottomMax >= rowTop;
        if (overflows || collides) {
          rowTop = rowBottomMax + gapRH;
          cursorCol = 1;
        }
        cell.style.setProperty(radStartProp, String(rowTop));
        cell.dataset[radStartDataKey] = String(rowTop);
        cursorCol += span;
      }
      const radEnd = appliceraCell(cell);
      rowBottomMax = Math.max(rowBottomMax, radEnd);
      maxRad = Math.max(maxRad, radEnd - 1);
    });

    grid.style.setProperty('--imgmod-rader-aktuell', String(maxRad));
    grid.dataset.imgmodLayout = 'klar';
  };
  const bindBildLoad = (rot) => {
    rot.querySelectorAll('[data-imgmod-cell] img').forEach((img) => {
      if (img.dataset.imgmodLoad === 'klar') return;
      img.dataset.imgmodLoad = 'klar';
      if (img.complete) return;
      img.addEventListener('load', () => layoutSektion(rot), { once: true });
    });
  };
  const initSektion = (rot) => {
    rot.querySelectorAll('[data-imgmod-galleri]').forEach((galleri) => {
      synkaIndex(galleri, 0);
      bindDrag(galleri);
    });
    bindBildLoad(rot);
    layoutSektion(rot);
    if (rot._imgmodRo) rot._imgmodRo.disconnect();
    const grid = rot.querySelector('.bxyz-imgmodular-1__grid');
    if (grid) {
      rot._imgmodRo = new ResizeObserver(() => layoutSektion(rot));
      rot._imgmodRo.observe(grid);
    }
  };
  document.addEventListener('click', (e) => {
    const knapp = e.target.closest('[data-atgard^="imgmodular/"]');
    if (!knapp) return;
    const galleri = valjGalleri(knapp);
    if (!galleri) return;
    e.preventDefault();
    const atgard = knapp.dataset.atgard.split('/')[1];
    if (atgard === 'foregaende') steg(galleri, -1);
    if (atgard === 'nasta') steg(galleri, 1);
  });
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => document.querySelectorAll('[data-imgmod-sektion]').forEach(initSektion), 120);
  });
  document.querySelectorAll('[data-imgmod-sektion]').forEach(initSektion);
  document.addEventListener('shopify:section:load', (e) => {
    const rot = e.target.querySelector('[data-imgmod-sektion]') || (e.target.matches('[data-imgmod-sektion]') ? e.target : null);
    if (rot) initSektion(rot);
  });
})();
